/**
 *
 * @param { value: valueToValidate, message: 'CustomErrorMessage' } opts
 * @returns { valid: true/false, messages: Array}
 */
export default class NumericValidator {
	constructor(opts) {
		this.validateOn = 'input';

		if (opts) {
			this.customMessage = opts.message;

			if (opts.validateOn) {
				this.validateOn = opts.validateOn;
			}
		}

		this.defaultMessage = 'Value must be a number';
		this.result = { valid: true };
	}

	validate(value) {
		this.result.valid = true;
		this.value = value;

		if (this.value && isNaN(this.value)) {
			this.result.valid = false;
		}

		if (!this.result.valid) {
			if (this.customMessage) {
				this.result.messages = [this.customMessage];
			} else {
				this.result.messages = [this.defaultMessage];
			}
		}

		return this.result;
	}
}
